import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Paragrapher from 'components/UI/Paragrapher/Paragrapher';
// import BlockTitle from 'components/UI/BlockTitle';
// import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
// import Badge from '@material-ui/core/Badge';
import Avatar from '@material-ui/core/Avatar';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import config from 'config/api';
import i18n from 'helpers/i18n';
import getCardImage from 'helpers/getCardImage';
import getCardGuests from 'helpers/getCardGuests';
// import { fetchData, getDataHome, getSubscriptions, getAvailableEvents, getReplayEvents } from '../../ducks/asyncFetcher';
import { fetchData, getDataHome, getAvailableEvents, getReplayEvents } from '../../ducks/asyncFetcher';
import { fetchEvents } from 'components/UI/Event/ducks/event';
import { formatDate } from 'helpers/stringUtils';
import { toHHMM } from 'helpers/time';
import Button from '@material-ui/core/Button';
import DateRangeIcon from '@material-ui/icons/DateRange';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import BlockRatio from 'components/BlockRatio';
// import Spinner from 'components/UI/Spinner/Spinner';
// import SwipeableViews from 'react-swipeable-views';
// import { autoPlay } from 'react-swipeable-views-utils';
// import MobileStepper from '@material-ui/core/MobileStepper';
import IconButton from '@material-ui/core/IconButton';
// import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
// import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
// import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
// const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const styles = (theme) => {
  return {
    root: {
      // '& .MuiTypography-h3': {
      //   paddingRight: 4,
      //   paddingLeft: 22,
      //   marginBottom: theme.spacing(2),
      // },
      // '& .MuiSvgIcon-root': {
      //   fontSize: '1.1rem'
      // },
      // '& .MuiButton-root': {
      //   marginBottom: theme.spacing(2)
      // },
      height: '100%',
      // marginBottom: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    itemWrapper: {
      display: 'flex',
      overflow: 'hidden',
      width: '100%',
      borderRadius: 5,
      // border: '1px #1D202126 solid',
      backgroundColor: '#EFEBEF',
      // paddingBottom: theme.spacing(3),
      // width: 'calc(100% - '+(8*9)+'px)',
      height: '100%',
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
      '& > div': {
        width: '100%'
      },
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        padding: 0,
        // paddingLeft: theme.spacing(2),
        // paddingRight: theme.spacing(2),
      },
      [theme.breakpoints.down('sm')]: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        // padding: theme.spacing(1),
        padding: 0,
      }
    },
    itemContentWrapper: {
      paddingTop: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      [theme.breakpoints.down('md')]: {
        // marginLeft: theme.spacing(1),
        // marginRight: theme.spacing(1),
      }
    },
    itemThumbnailWrapper: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
    itemThumbnail: {
      position: 'relative',
      width: '100%',
      height: '100%',
      // height: 200,
      backgroundRepeat: "no-repeat",
      backgroundPosition: '50%',
      backgroundSize: 'cover',
      backgroundColor: '#e9e2e9'
      // marginBottom: theme.spacing(3),
    },
    itemThumbnailVertical: {
      backgroundPosition: '50% -20px'
    },
    itemTheme: {
      marginBottom: theme.spacing(.5),
      fontSize: '0.75rem',
      lineHeight: '1.5'
    },
    itemTitle: {
      width: '100%',
      marginBottom: theme.spacing(3),
      // color: theme.palette.primary.dark,
      // fontWeight: 'bold',
    },
    itemDescription: {
      width: '100%',
      marginBottom: theme.spacing(3),
    },
    itemDate: {
      width: '100%',
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
    },
    itemPrecisions: {
      width: '100%',
      marginBottom: theme.spacing(1.5),
      '&:last-of-type': {
        marginBottom: theme.spacing(3),
      }
    },
    itemPrecisionsSpacer: {
      [theme.breakpoints.down('xs')]: {
        display: 'none'
      }
    },

    invisible: {
      visibility: 'hidden'
    },
    liveNavigation: {
      '& .MuiButton-root.MuiButton-containedPrimary': {
        backgroundColor: theme.palette.secondary.light,
        borderColor: theme.palette.secondary.light,
        color: '#fff',
        // fontWeight: 'bold',
        fontWeight: 700,
        '&:hover': {
          backgroundColor: '#fff',
          // borderColor: '#fff',
          color: theme.palette.secondary.light,
          borderColor: theme.palette.secondary.light,
        }
      },
      '& .MuiTypography-body1': {
        display: 'inline-block',
        marginLeft: theme.spacing(1),
        color: theme.palette.secondary.light,
        // fontWeight: 'bold'
        fontWeight: 700,
      }
    },
    iconPlay: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: '#fff',
      fontSize: '10rem',
      width: 100,
      height: 100,
      cursor: 'pointer'
    },
    itemGuests: {
      marginBottom: theme.spacing(3),
      '& .MuiTypography-caption': {
        marginBottom: theme.spacing(2),
      },
      '& .MuiTypography-body1': {
        // fontWeight: 'bold'
        fontWeight: 700,
      }
    },
    itemAvatars: {
      // marginLeft: theme.spacing(-1),
      marginBottom: theme.spacing(1),
      // paddingRight: theme.spacing(2),
      '& .MuiSvgIcon-root': {
        margin: 0
      },
      '& .MuiAvatar-colorDefault': {
        color: theme.palette.secondary.light,
      }

    },
    itemGuestName: {
      // paddingLeft: theme.spacing(.4),
      paddingRight: theme.spacing(.4),
      marginRight: theme.spacing(1),
      display: 'inline-block',
      position: 'relative',
      '&:before': {
        content: "','",
        textAlign: 'right',
        position: 'absolute',
        right: 0,
        // color: "red",
        width: '100%',
        height: '100%'
      },
      '&:last-of-type': {
        paddingRight: 0,
        marginRight: 0,
        '&:before': {
          content: "' '",
        }
      }
    }
  };
};


class EventCard extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     activeStep: 0,
  //     groupStep: 3
  //   }
  // }

  componentDidMount() {
    // this.props.onMount({kind: this.props.kind})
    // this._onWindowResize();
    // window.addEventListener('resize', this._onWindowResize);
  }

  componentDidUpdate(oldProps) {
    // if (oldProps.$$availableEvents !== this.props.$$replayEvents || oldProps.$$replayEvents !== this.props.$$availableEvents) {
    //   this._onWindowResize();
    // }
  }


  gotoEvent = (e, $$event) => {
    e.preventDefault();
    const { history } = this.props;
    history.push('/event/' + $$event.get('id'));
  }

  gotoLive = (e, $$event) => {
    e.preventDefault();
    const { history } = this.props;
    history.push('/live/' + $$event.get('id'));
  }

  gotoReplay = (e, $$event) => {
    e.preventDefault();
    const { history } = this.props;
    history.push('/replays/' + $$event.get('id'));
  }
  render() {
    const { $$item, itemIndex, classes, kind, variant, isSubscribed } = this.props;
    // if ($$item !== undefi  ned)
    // console.log($$item.get('eventGuestsThumb') )
    const $$guests = getCardGuests($$item);
    // if ($$item !== undefined)
    // console.log($$item.get('eventGuestsThumb'))
    // console.log({isSubscribed})
    const imagePosition = variant ? variant : "horizontal"
    const thumb = getCardImage($$item);
    return (
      <Grid item xs={12} container justifyContent={'flex-start'} alignContent="flex-start" className={classes.root}>
        <Paper className={classes.itemWrapper} elevation={0} element="div">
          <Fade  delay={250*(itemIndex ? itemIndex+1 : 1)} cascade style={{height: '100%'}}>
            <Grid container style={{height: '100%'}} alignContent="flex-start">
              <Grid item xs={imagePosition === 'horizontal' ? 5 : 12} container alignContent={imagePosition !== 'horizontal' ? 'center' : 'flex-start'} style={{position: 'relative'}}>
                <Box className={classes.itemThumbnailWrapper} >
                  <BlockRatio ratio="16_9" style={{height: imagePosition === 'horizontal' ? '100%' : undefined}}>
                    <div className={clsx(classes.itemThumbnail, {
                        [classes.itemThumbnailHorizontal]: imagePosition === 'horizontal' && thumb === false,
                        [classes.itemThumbnailVertical]: imagePosition !== 'horizontal' && thumb === false
                      })} style={{backgroundImage: 'url('+(thumb !== false ? thumb : require('assets/images/event.png'))+')'}}></div>
                    {/*<If condition={kind === 'replays'}>
                      <IconButton className={classes.iconPlay}  onClick={e => this.gotoReplay(e, $$item)}>
                        <PlayCircleOutlineIcon style={{width: '100%', height: '100%', margin: 0}}/></IconButton>
                      </If>
                      <If condition={kind === 'events' && $$item.get('eventState') === 'live'}>
                        <IconButton className={classes.iconPlay}  onClick={e => this.gotoLive(e, $$item)}>
                          <PlayCircleOutlineIcon style={{width: '100%', height: '100%', margin: 0}}/></IconButton>
                        </If>*/}
                      </BlockRatio>
                    </Box>
                  </Grid>
                  <Grid item xs={imagePosition === 'horizontal' ? 7 : 12} container alignContent="flex-start" className={classes.itemContentWrapper}>
                    <Typography variant="subtitle1" component="div" gutterBottom className={classes.itemTheme}>
                      <Paragrapher
                        text={$$item.get('themeName')}
                        prettyfy={true}
                        element={'div'}
                        />
                    </Typography>
                    <If condition={kind !== 'replays'}>
                      {/*  <Typography variant="body1" component="div" gutterBottom className={classes.itemDate}>
                      <DateRangeIcon/> {formatDate($$item.get('eventDate'), "dddd dd mmmm yyyy - HH'h'MM")}
                      <If condition={$$item.get('eventDuration') && $$item.get('eventDuration') !== false && $$item.get('eventDuration') !== false && $$item.get('eventDuration') !== '' && $$item.get('eventDuration') > 0}>
                      {formatDate($$item.get('eventDate')+($$item.get('eventDuration')*60), " - HH'h'MM")}
                      </If>
                      </Typography>*/}
                    </If>
                    <Typography variant="h5" component="div" gutterBottom className={classes.itemTitle}>
                      <Paragrapher
                        text={$$item.get('eventTitle')}
                        elementClassName={classes.content}
                        prettyfy={true}
                        element={'div'}
                        />
                    </Typography>
                    <If condition={$$item.get('eventShortDescription')}>
                      <Typography variant="body1" component="div" gutterBottom className={classes.itemDescription}>
                        <Paragrapher
                          text={$$item.get('eventShortDescription')}
                          elementClassName={classes.content}
                          prettyfy={true}
                          element={'div'}
                          />
                      </Typography>
                    </If>
                      {/*  <If condition={kind !== 'replays'}>
                      <DateRangeIcon/> {formatDate($$item.get('eventDate'), "dddd dd mmmm yyyy - HH'h'MM")}
                      <If condition={$$item.get('eventDuration') && $$item.get('eventDuration') !== false && $$item.get('eventDuration') !== false && $$item.get('eventDuration') !== '' && $$item.get('eventDuration') > 0}>
                      {formatDate($$item.get('eventDate')+($$item.get('eventDuration')*60), " - HH'h'MM")}
                      </If>
                      </If>*/}
                      <If condition={kind !== 'replays'}>
                      <Typography variant="caption" component="div" gutterBottom className={classes.itemDate}>
                        <DateRangeIcon/> {formatDate($$item.get('eventDate'), "ddd dd mmmm yyyy - HH'h'MM")}
                        <If condition={$$item.get('eventDuration') && $$item.get('eventDuration') !== false && $$item.get('eventDuration') !== false && $$item.get('eventDuration') !== '' && $$item.get('eventDuration') > 0}>
                          {formatDate($$item.get('eventDate')+($$item.get('eventDuration')*60), " - HH'h'MM")}
                        </If>
                        <If condition={$$item.get('eventDuration') && $$item.get('eventDuration') !== false && $$item.get('eventDuration') !== false && $$item.get('eventDuration') !== '' && $$item.get('eventDuration') > 0}>
                        </If>
                      </Typography>

                      </If>

                        <If condition={$$item.get('eventDuration') && $$item.get('eventDuration') !== false && $$item.get('eventDuration') !== false && $$item.get('eventDuration') !== '' && $$item.get('eventDuration') > 0}>
                          <If condition={kind !== 'replays'}>{/*&nbsp;&nbsp;|&nbsp;&nbsp;*/}</If>
                            <Typography variant="caption" component="div" gutterBottom className={classes.itemPrecisions}>
                              <WatchLaterIcon/> {i18n.get('eventDuration', {pretty: false})} {toHHMM($$item.get('eventDuration')*60)}
                              </Typography>
                          </If>
                        <If condition={$$guests !== false && $$guests.size > 0}>
                          <Grid item xs={12} container>
                            {/*
                              {$$guests.map(($$g, aIdx) => {
                              return (
                              <Grid item xs={12} key={'av_'+aIdx} container >
                              <Grid item xs={3}>
                              <Avatar src={$$g.get('dest')} alt={$$g.getIn(['attributes','name'])}/>
                              </Grid>
                              <Grid item xs={9}>
                              <Typography variant={'caption'} gutterBottom>{i18n.get('eventAnimatedBy',{pretty: false})}</Typography>
                              <Typography variant={'body1'} gutterBottom>{$$g.getIn(['attributes','name'])}</Typography>
                              </Grid>
                              </Grid>)
                              }).toArray()}
                              */}
                              <Box className={classes.itemGuests}>
                                <Typography variant={'caption'} gutterBottom>{i18n.get('eventAnimatedBy',{pretty: false})}</Typography>
                                <Box className={classes.itemAvatars} mt={0.5}>
                                  <AvatarGroup max={5} spacing={'medium'}>
                                    {$$guests.map(($$g, aIdx) => {
                                      return (
                                        <Avatar size="small" key={'av_'+aIdx} src={$$g.get('dest')} alt={$$g.getIn(['attributes','name'])}/>
                                      )
                                    }).toArray()}
                                  </AvatarGroup>
                                </Box>
                                <Typography variant={'body1'} gutterBottom>
                                  {$$guests.map(($$g, aIdx) => {
                                    return <span key={'an_'+aIdx} className={classes.itemGuestName}>{$$g.getIn(['attributes','name'])}</span>
                                  }).toArray()}
                                </Typography>
                              </Box>


                            </Grid>
                          </If>
                          <If condition={kind === 'events'}>
                            <Choose>
                              <When condition={$$item.get('eventState') === 'live'}>
                                <Box className={classes.liveNavigation} mb={2}>
                                  <Button variant="contained" color="primary" onClick={e => this.gotoLive(e, $$item)} >{i18n.get('liveAction')}</Button> <Typography variant="body1">{i18n.get('liveEventIsStarted')}</Typography>
                                </Box>
                              </When>
                              {/*<When condition={$$item.get('eventState') !== 'live' && $$subscriptions.find(id => id === $$item.get('id'))}>
                              <Box className={classes.liveNavigation}>
                              <Button variant="contained" color="primary" onClick={e => this.gotoLive(e, $$item)} disabled={true}>{i18n.get('subscriptionAlreadyExists',{pretty: false})}</Button>
                              </Box>
                              </When>*/}
                              <When condition={isSubscribed === true}>
                                <Box className={classes.liveNavigation} mb={2}>
                                  <Button variant="contained" color="primary" onClick={e => this.gotoEvent(e, $$item)} >{i18n.get('subscriptionShowProgram')}</Button> <Typography variant="body1">{i18n.get('subscriptionAlreadyExists')}</Typography>
                                </Box>
                              </When>
                              <Otherwise>
                                <Box className={classes.liveNavigation} mb={2}>
                                <Button variant="contained" color="primary" onClick={e => this.gotoEvent(e, $$item)}>{i18n.get('subscribeAction')}</Button>
                                </Box>
                              </Otherwise>
                            </Choose>
                          </If>
                          <If condition={kind === 'replays'}>
                            <Box className={classes.liveNavigation} mb={2}>
                            <Button variant="contained" color="primary" onClick={e => this.gotoReplay(e, $$item)}>{i18n.get('replayAction')}</Button>
                            </Box>
                          </If>
                        </Grid>
                      </Grid>
                    </Fade>
                  </Paper>
                </Grid>
              );
            }
          }
          function mapStateToProps(state) {
            const props = {
              $$data: getDataHome(state),
              // $$subscriptions: getSubscriptions(state),
              $$availableEvents: getAvailableEvents(state),
              $$replayEvents: getReplayEvents(state),
              // $$user: getCurrentUser(state),
            };
            return props;
          }
          function mapDispatchToProps(dispatch) {
            return {
              onMount: (props) => {
                dispatch(fetchData({ key: 'home', fetchUrl: config.home }));
                dispatch(fetchEvents({ kind: props.kind }));
              },
            };
          }

          export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EventCard)));



// WEBPACK FOOTER //
// ./src/components/Event/EventCard.jsx